// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__-6Rit","productName":"Table_productName__393x2"};